import { FormattedMessage } from 'react-intl'
import { NavLink } from 'react-router-dom'

import { TabsWrapper, Tabs, Tab } from 'components/Tabs'

export const SnacksTabs = (props: TSFixMe): TSFixMe => {
  return (
    <TabsWrapper>
      <Tabs>
        <Tab as={NavLink} to="/snacks/products" isActive={(props: TSFixMe): TSFixMe => props && props.isExact}>
          <FormattedMessage id="spanish.snacks.tabs.products" defaultMessage="Productos" />
        </Tab>

        <Tab as={NavLink} to="/snacks/combos" isActive={(props: TSFixMe): TSFixMe => props && props.isExact}>
          <FormattedMessage id="spanish.snacks.tabs.combos" defaultMessage="Combos" />
        </Tab>

        <Tab as={NavLink} to="/snacks/plans" isActive={(props: TSFixMe): TSFixMe => props && props.isExact}>
          <FormattedMessage id="spanish.snacks.tabs.plans" defaultMessage="Plans" />
        </Tab>
      </Tabs>
    </TabsWrapper>
  )
}
